export enum AdsCategory {
  MY_ADS = 'MY_ADS',
  ALL_ADS = 'ALL_ADS',
}
